import VcImagePlaceholder from './vc-image-placeholder'

VcImagePlaceholder.install = function install (Vue) {
  Vue.component(VcImagePlaceholder.name, VcImagePlaceholder)
}

export default VcImagePlaceholder



// WEBPACK FOOTER //
// ./src/components/vc-image-placeholder/index.js